import Modal from "../../gui/Modal";
import AbstractTool from "../AbstractTool";

export default class ImageTool extends AbstractTool {
    scrollEnabled = true;
    resetPreviousTool = true;

    activate() {
        super.activate();
        this.imageMenu.activate();
        this.cursor.grab();
    }

    deactivate() {
        super.deactivate();
        this.imageMenu.deactivate();
        this.reset();
    }

    display() {
        if (!this.image?._loaded) {
            return;
        }
        if (this.mode == 'scale' && this.firstCoordinate && !this.secondCoordinate) {
            this.p.stroke(255);
            this.p.strokeWeight(2.5);
            this.p.line(
                this.firstCoordinate.currentX,
                this.firstCoordinate.currentY,
                this.view.coordinate.currentX,
                this.view.coordinate.currentY
            );
            this.p.stroke(0);
            this.p.strokeWeight(1);
            this.p.line(
                this.firstCoordinate.currentX,
                this.firstCoordinate.currentY,
                this.view.coordinate.currentX,
                this.view.coordinate.currentY
            );
        }
    }

    pressMouseOnCanvas() {
        if (!this.image?._loaded) {
            return;
        }
        if (this.mode == 'move') {
            this.dragging = this.image.hoveredWithSupport();
        } else if (this.mode == 'rotate' && this.image.hovered()) {
            this.startAngle = this.image.center.angleTo(this.view.coordinate);
            this.imageAngle = this.image.rotation;
        } else if (this.mode == 'scale') {
            if (!this.firstCoordinate) {
                this.firstCoordinate = this.view.coordinate;
            } else {
                this.secondCoordinate = this.view.coordinate;
                this.askDimensions();
            }
        }
    }

    dragMouse() {
        if (!this.image?._loaded) {
            return;
        }
        if (this.mode == 'move') {
            if (this.dragging) {
                this.cursor.grabbing();
                let moveX = this.p.movedX / this.view.scale;
                let moveY = this.p.movedY / this.view.scale;
                if (moveX != 0 || moveY != 0) {
                    this.dragging.move(moveX, moveY);
                    this.changesMade();
                }
            }
        } else if (this.mode == 'rotate') {
            if (this.imageAngle !== null) {
                this.cursor.grabbing();
                this.image.rotation = this.imageAngle - this.startAngle + this.image.center.angleTo(this.view.coordinate);
            }
        } else {

        }
    }

    releaseMouseOnCanvas() {
        if (!this.image?._loaded) {
            return;
        }
        if (this.mode == 'move') {
            this.dragging = false;
            this.image.mouseOver();
        } else if (this.mode == 'rotate') {
            this.startAngle = null;
            this.imageAngle = null;
            this.image.hovered()
                ? this.cursor.grab()
                : this.cursor.arrow();
        }
    }

    moveMouse() {
        if (!this.image?._loaded) {
            return;
        }
        if (this.mode == 'move') {
            this.image.mouseOver();
        } else if (this.mode == 'rotate') {
            this.image.hovered()
                ? this.cursor.grab()
                : this.cursor.arrow();
        } else if (this.mode == 'scale') {
            this.cursor.cross();
        }
    }

    getTips() {
        if (this.mode == 'move') {
            return "Drag the image to move it. Drag corners to resize";
        } else if (this.mode == 'rotate') {
            return "Drag the image to rotate it. Make adjustments with arrow keys, left/right (small) and up/down (larger).";
        }
        return "Pick two points and specify the distance between them."
    }

    askDimensions() {
        this.enableHotKeys = false;
        let dimensionsModal = new Modal(this.provider);
        let dimensionsContainer = this.p.createDiv()
            .class('input-group')
        let label = this.p.createDiv('Distance between points in ' + (this.settings.metric ? 'meters' : 'feet'))
            .parent(dimensionsContainer)
            .class('input-label');
        let dimensionsInput = this.p.createInput(0, 'float')
            .class('input-text')
            .parent(dimensionsContainer);

        dimensionsModal.setTitle('Specify distance')
            .addContent(dimensionsContainer)
            .setButtonText('Save')
            .onClickCancel(() => {
                this.enableHotKeys = true;
                dimensionsModal.remove();
                this.reset();
            })
            .onClickButton(() => {
                this.enableHotKeys = true;
                dimensionsModal.remove();
                this.scaleImage(dimensionsInput.value());
            });
    }

    scaleImage(distance) {
        if (distance > 0) {
            let drawnDistance = this.firstCoordinate.absDistanceTo(this.secondCoordinate);
            let scale = (this.settings.metric ? distance : distance / 3.048) / (drawnDistance / 100);
            this.image.scale(scale);
        }
        this.reset();
    }

    reset() {
        this.firstCoordinate = null;
        this.secondCoordinate = null;
    }

    pressKey(code) {
        switch (code) {
            case 77: // M
                this.imageMenu.adjustModes.selected('move');
                return;
            case 81: // Q
                this.imageMenu.adjustModes.selected('scale');
                return;
            case 82: // R
                this.imageMenu.adjustModes.selected('rotate');
                return;
        }
        if (this.mode == 'move') {
            switch (code) {
                case 37: // left arrow
                    this.image.move(- this.grid.minorSize, 0);
                    // this.image.move(- this.grid.minorSize, 0);
                    break;
                case 38: // up arrow
                    this.image.move(0, - this.grid.minorSize);
                    break;
                case 39: // right arrow
                    this.image.move(this.grid.minorSize, 0);
                    // this.image.move(this.grid.minorSize, 0);
                    break;
                case 40: // down arrow
                    this.image.move(0, this.grid.minorSize);
                    break;
            }
        } else if (this.mode == 'rotate') {
            switch (code) {
                case 37: // left arrow
                    this.image.rotation += 0.005;
                    break;
                case 38: // up arrow
                    this.image.rotation += 0.05;
                    break;
                case 39: // right arrow
                    this.image.rotation -= 0.005;
                    break;
                case 40: // down arrow
                    this.image.rotation -= 0.05;
                    break;
            }
        } else {
            switch (code) {
                case 27: // Esc
                    this.reset();
                    break;
            }
        }
    }

    get mode() {
        return this.imageMenu.adjustModes.value();
    }
}
